import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadVersionListBegin, loadVersionListFailed,
  loadVersionListSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import {
  BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, TYPE_ROLLBACK_ENUM,
} from '../../../configs';

export default function* loadVersionList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
    } = payload;
    const pool = {
      limit,
      page,
    };

    const defaultType = action.payload?.type || TYPE_ROLLBACK_ENUM.APPLICATION;
    const url = `${BACKEND_URL}${defaultType}${action.payload?.id}/versions`;
    yield put(loadVersionListBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadVersionListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadVersionListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadVersionListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
